/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '@mantum/kanela-request';
import { source } from '@mantum/kanela';

import type { Parameter } from '@mantum/kanela';

type Option = {
    namespace?: string;
    parameter?: Parameter;
    headers?: Record<string, string>;
};

export default (url: string, option?: Option): Promise<unknown[]> => {
    return new Promise((resolve, reject) => {
        const response = request.get(url, {
            parameter: option?.parameter,
            headers: option?.headers
        });

        response.then((values: unknown[]) => {
            resolve(source.extract(values, option?.namespace));
        });

        response.catch(reject);
    });
};
